const CONFIG = [{
	name: 'mainnet',
	chainId: 1,
	factory: '0xDE09B87e50F65031DF6A3C3AA0E2f0EfCE5E2Cf6',
	explorer: 'https://etherscan.io/',
},{
	name: 'gnosis',
	chainId: 100,
	rpcs: [ 'https://rpc.gnosischain.com' ],
	factory: '0x6769b73598da4e4d697209aa400f05ed2217d525',
	explorer: 'https://gnosisscan.io/',
},{
	name: 'polygon (matic)',
	chainId: 137,
	factory: '0x7fD3cdd52fb6e0Bfe4D072e0D082e670c98dA388',
	explorer: 'https://polygonscan.com/',
},{
	name: 'sepolia (testnet)',
	chainId: 11155111,
	factory: '0xdAb4Da4369de92aB1F3819C31A41fc7060C10a8c',
	explorer: 'https://sepolia.etherscan.io/',
},{
	name: 'amoy (polygon testnet)',
	chainId: 80002,
	rpcs: [ 'https://rpc-amoy.polygon.technology' ],
	factory: '0x697bCd5513F62773030135cA227848C4F499F7e4',
	explorer: 'https://www.oklink.com/amoy',
}];

export default CONFIG;
